export default __webpack_public_path__ + "5a5cc8c56ef1e6f1f030072ebac8de98.svg";